<template>
    <div :id="'prtD-' + event.id" class="collapse" :class="{show: event.$show}" v-bind:aria-labelledby="'prtH-' + event.id">
        <div v-if="!loaded">
            <div class="loading-container">
                <div class="loading">{{ $t('Laeb ...') }}</div>
            </div>
        </div>

        <div v-if="loaded">
            <div class="row">
                <div class="col-12 my-3">
                    <h4>{{ $t('Minu tulemused') }}</h4>

                    <p v-for="successMessage in notificationsResults.successes" class="text-success my-2">
                        {{ successMessage }}
                    </p>
                    <p v-for="errorMessage in notificationsResults.errors" class="text-danger my-2">
                        {{ errorMessage }}
                    </p>

                    <div class="row" v-for="prt in event.$myParticipants">
                        <div class="col-12">

                            <h5 class="mt-3">{{ prt.name }}</h5>

                            <p v-if="event.is_challenge && results[prt.id] && results[prt.id].length > 0"
                               :class="{'text-success': results[prt.id][0].$resultsTotal >= event.target_result}">
                                {{ $t('Eesmärk') }}: {{ Filters.distance(event.target_result) }},
                                {{ $t('Tehtud') }}: {{ Filters.distance(results[prt.id][0].$resultsTotal) }}
                            </p>

                            <table class="table">
                                <thead class="header-gray">
                                    <tr>
                                        <th style="width: 5%">#</th>
                                        <th style="width: 15%">{{ $t('Kuupäev') }}</th>
                                        <th style="width: 15%">{{ $t('Distants') }}</th>
                                        <th style="width: 25%">{{ $t('Pilt') }}</th>
                                        <th style="width: 15%">{{ $t('Spordiala') }}</th>
                                        <th style="width: 15%">{{ $t('Aeg') }}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody v-if="results[prt.id] && results[prt.id].length > 0">
                                    <tr v-for="(r, k) in results[prt.id]">
                                        <td>{{ k + 1 }}</td>
                                        <td>
                                            <span>{{ r.workout_date }}</span>
                                            <span v-if="r.workout_date_end"> - {{ r.workout_date_end }}</span>
                                        </td>
                                        <td>
                                    <span v-if="event.is_challenge">
                                        <span>{{ Filters.distance(r.result) }}</span>
                                    </span>
                                            <span v-else>
                                        <span v-if="r.distance">{{ r.distance.distance_displayed }}</span>
                                    </span>
                                        </td>
                                        <td>
                                            <img class="img-fluid" v-if="r.image" :src="r.image" :alt="$t('Pilt tulemusest')">
                                            <span v-else>-</span>
                                        </td>
                                        <td>
                                            <span>{{ r.sportName }}</span>
                                        </td>
                                        <td>
                                            <span v-if="!event.is_challenge">{{ Filters.hhmmss(r.result) }}</span>
                                            <span v-else>-</span>
                                        </td>
                                        <td class="text-right">
                                            <a href="" class="border-0 text-danger" v-on:click.prevent="removeResult(r.id)">
                                                <i class="fa fa-trash mr-1"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="6" class="text-center">{{ $t('Tulemusi pole lisatud') }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <h5 v-if="event.is_virtual && event.$ongoing">{{ $t('Tulemuse lisamine') }}</h5>
                    <div v-if="event.is_virtual && event.$ongoing" class="row">
                        <div class="form col-12">
                            <form action="#" class="resultForm">
                                <input name="is_challenge" type="hidden" v-model="newResult.is_challenge"/>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label class="field-label">{{ $t('Osaleja') }}</label>

                                        <div class="custom-control custom-radio my-2"
                                             v-for="regPrt in resultForm.fields.participant._choices">
                                            <input class="custom-control-input"
                                                   name="participant"
                                                   type="radio"
                                                   v-model="newResult.participant"
                                                   :class="{'is-invalid': resultForm.hasErrors('participant')}"
                                                   :value="regPrt.id"
                                                   :id="'prt-' + regPrt.id">
                                            <label class="custom-control-label" :for="'prt-' + regPrt.id">
                                                {{ regPrt.name }}
                                            </label>
                                            <div class="invalid-feedback" v-for="error in resultForm.getErrors('participant')">
                                                <div class="alert alert-danger">{{ error }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12" v-if="!event.is_challenge">
                                        <label class="field-label">{{ $t('Distants') }}</label>

                                        <div class="custom-control custom-radio my-2"
                                             v-for="(distDisp,distId) in resultForm.fields.distance._choices">
                                            <input class="custom-control-input"
                                                   name="distance"
                                                   type="radio"
                                                   v-model="newResult.distance"
                                                   :class="{'is-invalid': resultForm.hasErrors('distance')}"
                                                   :value="distId"
                                                   :id="'dst-' + distId">
                                            <label class="custom-control-label" :for="'dst-' + distId">
                                                {{ distDisp }}
                                            </label>
                                            <div class="invalid-feedback" v-for="error in resultForm.getErrors('distance')">
                                                <div class="alert alert-danger">{{ error }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row" v-if="!event.is_challenge">
                                    <div class="form-group col-12">
                                        <label class="field-label">{{ $t('Spordiala') }}</label>

                                        <div class="custom-control custom-radio my-2"
                                             v-for="(sportDisp,sportId) in resultForm.fields.sport._choices">
                                            <input class="custom-control-input"
                                                   name="sport"
                                                   type="radio"
                                                   v-model="newResult.sport"
                                                   :class="{'is-invalid': resultForm.hasErrors('sport')}"
                                                   :value="sportId"
                                                   :id="'sport-' + sportId">
                                            <label class="custom-control-label" :for="'sport-' + sportId">
                                                {{ sportDisp }}
                                            </label>
                                            <div class="invalid-feedback" v-for="error in resultForm.getErrors('sport')">
                                                <div class="alert alert-danger">{{ error }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-12">
                                        <label class="field-label">{{ $t('Lisan tulemuse') }}</label>
                                        <div class="custom-control custom-radio my-2">
                                            <input class="custom-control-input"
                                                   :name="'result_add_type' + event.id"
                                                   :id="'result_add_type_man' + event.id"
                                                   :key="'result_add_type' + event.id"
                                                   :value="'add_type_man_' + event.id"
                                                   type="radio"
                                                   v-model="newResult.$addType">
                                            <label class="custom-control-label" :for="'result_add_type_man' + event.id">
                                                {{ $t('Käsitsi') }}
                                            </label>
                                        </div>
                                        <div class="custom-control custom-radio my-2">
                                            <input class="custom-control-input"
                                                   :name="'result_add_type' + event.id"
                                                   :id="'result_add_type_file' + event.id"
                                                   :key="'result_add_type' + event.id"
                                                   :value="'add_type_file_' + event.id"
                                                   type="radio"
                                                   v-model="newResult.$addType">
                                            <label class="custom-control-label" :for="'result_add_type_file' + event.id">
                                                {{ $t('Failist') }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row" v-if="newResult.$addType === 'add_type_man_' + event.id">
                                    <div class="form-group col-12">
                                        <label class="field-label">{{ $t('Märgi tulemus') }}</label>
                                        <div class="form-row" v-if="!event.is_challenge">
                                            <div class="form-group col-3">
                                                <label for="resultHours">{{ $t('Tunnid') }}</label>
                                                <input type="number" class="form-control" id="resultHours"
                                                       min="0"
                                                       max="99"
                                                       maxlength="2"
                                                       onfocus="this.select()"
                                                       v-model="newResult._hours"
                                                       v-on:change="updateResultValue()" v-on:blur="updateResultValue()">
                                            </div>
                                            <div class="form-group col-3">
                                                <label for="resultMinutes">{{ $t('Minutid') }}</label>
                                                <input type="number" class="form-control" id="resultMinutes"
                                                       min="0"
                                                       max="59"
                                                       maxlength="2"
                                                       onfocus="this.select()"
                                                       v-model="newResult._minutes"
                                                       v-on:change="updateResultValue()" v-on:blur="updateResultValue()">
                                            </div>
                                            <div class="form-group col-3">
                                                <label for="resultSeconds">{{ $t('Sekundid') }}</label>
                                                <input type="number" class="form-control" id="resultSeconds"
                                                       min="0"
                                                       max="59"
                                                       maxlength="2"
                                                       onfocus="this.select()"
                                                       v-model="newResult._seconds"
                                                       v-on:change="updateResultValue()" v-on:blur="updateResultValue()">
                                            </div>
                                        </div>
                                        <div class="form-row" v-if="event.is_challenge">
                                            <div class="form-group col-3">
                                                <label for="resultKm">{{ $t('Kilomeetrid') }}</label>
                                                <input type="text" class="form-control" id="resultKm"
                                                       onfocus="this.select()"
                                                       v-model="newResult._resultKm"
                                                       v-on:change="updateResultValue()" v-on:blur="updateResultValue()">
                                            </div>
                                        </div>
                                        <div v-for="error in resultForm.getErrors('result')">
                                            <div class="alert alert-danger">{{ error }}</div>
                                        </div>
                                        <div class="form-row" v-if="event.is_challenge">
                                            <div class="form-group col-6">
                                                <label>{{ $t('Kuupäev (või alguskuupäev)') }}</label>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <datepicker v-model="newResult.workout_date"
                                                                    :locale="dateLocale"
                                                                    :inputFormat="'dd.MM.yyyy'"
                                                        />
                                                        <div class="invalid-feedback" v-for="error in resultForm.getErrors('workout_date')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group col-6">
                                                <label>{{ $t('Lõpukuupäev') }}</label>
                                                <div class="form-row">
                                                    <div class="form-group col-12">
                                                        <datepicker v-model="newResult.workout_date_end"
                                                                    :locale="dateLocale"
                                                                    :inputFormat="'dd.MM.yyyy'"/>
                                                        <div class="invalid-feedback" v-for="error in resultForm.getErrors('workout_date_end')">
                                                            <div class="alert alert-danger">{{ error }}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row" v-if="newResult.$addType === 'add_type_file_' + event.id">
                                    <div class="form-group col-12">
                                        <label class="field-label">{{ $t('Lisa fail') }}</label>
                                        <div class="form-row">
                                            <div class="form-group col-12">
                                                <input type="file" class="form-control" id="resultFile"
                                                       :class="{'is-invalid': resultForm.hasErrors('workout_file')}"
                                                       @change="selectWorkoutFile">
                                                <small class="form-text text-muted">
                                                    {{ $t('Lubatud failitüübid') }}: {{ validWorkoutTypes.map(v => '.' + v).join(', ') }}.
                                                    {{ $t('Faili maht kuni 10MB') }}.
                                                </small>
                                                <div class="invalid-feedback" v-for="error in resultForm.getErrors('workout_file')">
                                                    <div class="alert alert-danger">{{ error }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-6">
                                        <label class="field-label" for="imageFile">{{ $t('Lisa pilt') }}</label>
                                        <div class="form-row">
                                            <div class="form-group col-12">
                                                <input type="file" class="form-control" id="imageFile"
                                                       :class="{'is-invalid': resultForm.hasErrors('image_file')}"
                                                       @change="selectImageFile">
                                                <small class="form-text text-muted">
                                                    {{ $t('Lubatud failitüübid') }}: {{ validImageTypes.map(v => '.' + v).join(', ') }}.
                                                    {{ $t('Faili maht kuni 10MB') }}.
                                                </small>
                                                <div class="invalid-feedback" v-for="error in resultForm.getErrors('image_file')">
                                                    <div class="alert alert-danger">{{ error }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row action-btn-row">
                                    <div class="col-12">
                                        <button class="btn btn-success action-btn" v-on:click.prevent="saveResult()">
                                            {{ $t('Lisa') }}
                                        </button>

                                        <p v-for="successMessage in notificationsAddResult.successes" class="text-success my-2">
                                            {{ successMessage }}
                                        </p>
                                        <p v-for="errorMessage in notificationsAddResult.errors" class="text-danger my-2">
                                            {{ errorMessage }}
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Datepicker from 'vue3-datepicker';
import { et } from 'date-fns/locale';
import _ from 'lodash';
import Form from '../../form';
import MrtApi from '../../mrt-api';
import MrtMath from '../../mrt-math';
import Filters from '../../filters';
import MrtNotifications from '../../mrt-notifications';

const fileExtension = require('file-extension');

const defaultNewResult = {
    participant: null,
    distance: null,
    sport: null,
    result: 0,
    is_challenge: 0,
    workout_date: null,
    workout_date_end: null,
    _hours: 0,
    _minutes: 0,
    _seconds: 0,
};

export default {
    name: 'competition',
    components: {Datepicker},
    props: {
        'eventId': Number
    },
    setup() {
        return {
            Filters
        };
    },
    data() {
        return {
            loaded: false,
            results: [],
            moment: moment,
            event: {
                $show: false,
            },
            newResult: _.clone(defaultNewResult),
            resultForm: new Form({}),
            notificationsAddResult: new MrtNotifications(),
            notificationsResults: new MrtNotifications(),
            validWorkoutTypes: ['gpx', 'tcx', 'fit'],
            validImageTypes: ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'],
            dateLocale: et
        };
    },
    mounted() {
        this.emitter.on('load-competition', (triggeredId) => {
            if (this.eventId !== triggeredId) {
                return;
            }

            this.onLoadCompetition();
        });
    },
    methods: {
        onLoadCompetition() {
            this.event.$show = !this.event.$show;
            if (!this.loaded && this.event.$show) {
                this.loadEvent();
            }
        },
        __loadEvent(response) {
            this.event = response.data.event;
            this.event.$show = true;

            this.results = response.data.results;

            this.resultForm = new Form(response.data.resultForm);
            this.resultForm.fields['participant']._choices = this.event.$myParticipants;
            this.resultForm.fields['distance']._choices = this.event.$distances;
            this.resultForm.fields['sport']._choices = this.event.$sports;

            let participantSelected = _.find(this.event.$myParticipants, {'$isMe': true});
            if (!participantSelected) {
                participantSelected = _.first(this.event.$myParticipants);
            }
            this.newResult.participant = participantSelected.id;

            this.newResult.is_challenge = this.event.is_challenge * 1;

            this.loaded = true;
        },
        loadEvent() {
            axios.get(MrtApi.createUrl(Mrt.config.routes['account.competitions.api.event'], [this.eventId]))
                .then(
                    (response) => {
                        this.__loadEvent(response);
                    }
                )
                .catch((err) => {
                    console.log(err);
                });
        },
        updateResultValue() {
            let finalSeconds = 0;
            this.newResult._hours = MrtMath.clamp(parseInt(this.newResult._hours), 0, 99);
            this.newResult._minutes = MrtMath.clamp(parseInt(this.newResult._minutes), 0, 59);
            this.newResult._seconds = MrtMath.clamp(parseInt(this.newResult._seconds), 0, 59);
            if (this.newResult._hours > 0) {
                finalSeconds += this.newResult._hours * 3600;
            }
            if (this.newResult._minutes > 0) {
                finalSeconds += this.newResult._minutes * 60;
            }
            if (this.newResult._seconds > 0) {
                finalSeconds += this.newResult._seconds;
            }

            this.newResult._resultKm = parseFloat(this.newResult._resultKm);
            if (this.newResult._resultKm > 0) {
                this.newResult.result = this.newResult._resultKm * 1000;
            } else {
                this.newResult.result = finalSeconds;
            }

        },
        isValidResult() {
            return this.newResult.workout_file || this.newResult.result > 0;
        },
        saveResult() {
            this.loaded = false;
            this.notificationsAddResult.reset();

            if (!this.isValidResult()) {
                this.notificationsAddResult.error(this.$t('Tulemust ei ole lisatud'));
                return;
            }

            const formData = new FormData();
            for (let key in this.newResult) {
                if (key === 'workout_date' || key === 'workout_date_end') {
                    continue;
                }
                let value = this.newResult[key];
                if (value === null) {
                    continue;
                }
                formData.append(key, value);
            }

            if (this.newResult['workout_date']) {
                formData.append('workout_date', this.newResult['workout_date'].getTime() / 1000);
            }
            if (this.newResult['workout_date_end']) {
                formData.append('workout_date_end', this.newResult['workout_date_end'].getTime() / 1000);
            }

            axios.post(MrtApi.createUrl(Mrt.config.routes['account.competitions.api.event'], [this.eventId]), formData)
                .then(
                    (response) => {
                        this.__resetForm();
                        this.newResult = _.clone(defaultNewResult);

                        this.__loadEvent(response);
                        if (response.data.status === 'success') {
                            this.notificationsAddResult.success(response.data.statusMsg || this.$t('Tulemus on lisatud'));
                        } else {
                            this.notificationsAddResult.error(
                                response.data.statusMsg
                                || this.$t('Tulemust ei lisatud. Vaata kas kõik vajalikud andmed on täidetud.')
                            );
                        }
                    }
                )
                .catch((err) => {
                    this.__resetForm();
                    this.newResult = _.clone(defaultNewResult);
                    this.notificationsAddResult.error(this.$t('Midagi läks valesti'));
                });
        },
        removeResult(id) {
            if (confirm('Kas olete kindel?')) {
                axios.post(MrtApi.createUrl(Mrt.config.routes['account.competitions.api.event'], [this.eventId]), {deleteResult: id})
                    .then(
                        (response) => {
                            this.newResult = _.clone(defaultNewResult);

                            this.__loadEvent(response);

                            if (response.data.status === 'success' && response.data.statusMsg) {
                                this.notificationsResults.success(response.data.statusMsg);
                            } else {
                                this.notificationsResults.error(response.data.statusMsg || this.$t('Tulemust ei õnnestunud kustutada.'));
                            }
                        }
                    )
                    .catch((err) => {
                        this.notificationsResults.error(this.$t('Tulemust ei õnnestunud kustutada.'));
                    });
            }
        },
        selectWorkoutFile(event) {
            this.newResult.workout_file = event.target.files[0];

            if (this.newResult.workout_file && this.validWorkoutTypes.indexOf(fileExtension(this.newResult.workout_file.name)) < 0) {
                this.resultForm.addError('workout_file', this.$t('Sellist faili me ei oska lugeda'));
                this.newResult.workout_file = null;
            }
        },
        selectImageFile(event) {
            this.newResult.image_file = event.target.files[0];

            if (this.newResult.image_file && this.validImageTypes.indexOf(fileExtension(this.newResult.image_file.name)) < 0) {
                this.resultForm.addError('image_file', this.$t('Sellist faili ei saa kahjuks lisada'));
                this.newResult.image_file = null;
            }
        },
        __resetForm() {
            Array.from(document.getElementsByClassName('resultForm')).forEach(el => el.reset());
        }
    }
};
</script>

<style scoped>

</style>
